import { Card, CardContent } from "@/components/ui/card";
import { useTranslation } from "react-i18next";
import { SourcedStat } from "@/components/SourcedStat";
import { SOCIAL_PROOF_STAT_IDS } from "@/data/industryStats";

const ClientLogos = () => {
  const { t } = useTranslation();
  const achievements = t("pages.home.clientLogos.achievements", { returnObjects: true }) as string[];

  return (
    <section className="section-padding bg-gradient-to-b from-background to-muted/20">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="text-section mb-4">
            {t("pages.home.clientLogos.title")}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t("pages.home.clientLogos.subtitle")}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6 mb-6">
          {SOCIAL_PROOF_STAT_IDS.map((id) => (
            <Card key={id} className="glass-card">
              <CardContent className="p-4 sm:p-6">
                <SourcedStat id={id} />
              </CardContent>
            </Card>
          ))}
        </div>
        <p className="text-center text-sm text-muted-foreground mb-16 max-w-3xl mx-auto">
          {t("industryStats.strip.disclaimer")}
        </p>

        <Card className="glass-card">
          <CardContent className="p-6 sm:p-8">
            <h3 className="text-lg sm:text-xl font-semibold mb-6 text-center">
              {t("pages.home.clientLogos.achievementsTitle")}
            </h3>
            <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-4">
              {achievements.map((achievement) => (
                <div key={achievement} className="flex items-start gap-3">
                  <div className="w-6 h-6 rounded-full bg-primary/10 flex items-center justify-center flex-shrink-0 mt-0.5">
                    <div className="w-2 h-2 rounded-full bg-primary"></div>
                  </div>
                  <p className="text-sm text-muted-foreground">{achievement}</p>
                </div>
              ))}
            </div>
          </CardContent>
        </Card>
      </div>
    </section>
  );
};

export default ClientLogos;
